import { useCallback, useState } from 'react';
import { parseError } from '@/utils';
import { DormitoryLegacyHttp } from '@/services';

export type PreRegisterFormPayload = {
  dormitoryId: number;
  description: string;
};

export default function useDormitoryPreRegisterForm() {
  const [submiting, setSubmiting] = useState(false);
  const [submitError, setSubmitError] = useState<string>('');

  const submit = useCallback(async (data: PreRegisterFormPayload) => {
    setSubmiting(true);
    setSubmitError('');
    try {
      return await DormitoryLegacyHttp.createPreRegisterRequest(data);
    }
    catch (e) {
      const err = parseError(e);
      setSubmitError(err);
      throw new Error(err);
    }
    finally {
      setSubmiting(false);
    }
  }, []);

  return { submit, submiting, submitError };
}
